export const getRandomInt = (min: number, max: number): number => {
  if (min > max) {
    throw new Error("Min cannot be bigger than max");
  }
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const generateId = (): string => {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
};
